module.exports = __webpack_public_path__ + "placa_td_loja_s_juros_carne.png?cdf60f4a600d520d0b65107de78c0f71";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/placa_td_loja_s_juros_carne.png
// module id = 134
// module chunks = 0